import React from 'react';
import styled from 'styled-components';
import { size } from '../../layout/helpers';
import { ImageCover, ImageCoverProps } from './ImageCover';

const Container = styled.main`
  padding-top: ${size(7)};
  display: flex;
  justify-content: center;

  ${(props) => props.theme.breakpoint.LtSm} {
    padding-top: 0;
    align-items: stretch;
    height: 100%;
  }
`;

const Column = styled.div`
  padding-block: ${size(9)};
  padding-inline: clamp(${size(3)}, 4vw, ${size(6)});
  margin-bottom: ${size(9)};
  max-width: 581px;
  background: ${(props) => props.theme.color.bg.alt};

  ${(props) => props.theme.breakpoint.LtSm} {
    margin-bottom: 0;
    padding-block: ${size(4)};
  }
`;

export const LayoutFullsizeBackgroundImage: React.FC<ImageCoverProps> = ({
  children,
  backgroundImageUrl,
}) => {
  return (
    <ImageCover backgroundImageUrl={backgroundImageUrl}>
      <Container>
        <Column>{children}</Column>
      </Container>
    </ImageCover>
  );
};
